// extracted by mini-css-extract-plugin
export var component = "Link-module--component--lWkoe";
export var current = "Link-module--current--y5fUW";
export var icon = "Link-module--icon--Z040I";
export var inert = "Link-module--inert--XvHb9";
export var label = "Link-module--label--KjjYU";